import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18069 36269"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#1c1b17}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M16472 12364h-334c390 23 856 308 856 629v274h487v-275c0-402-336-743-751-926 0 13 2 26 2 39 4 141-122 259-260 259zM1075 12992c0-271 335-519 674-602 56-14 112-21 167-26h-287c-137 0-264-119-259-259 0-18 2-36 2-54-430 179-784 528-784 942v274h487v-275zM1592 16462l-35-348h-437l34 348 547 5521h438zM16544 16114l-34 348-513 5168-34 353h437l36-353 512-5168 34-348h-16zM14391 35722H3712l-648-4407h-438l671 4814c11 79 105 140 217 140h11074c112 0 205-61 217-140l670-4814h-437l-647 4407zM2824 30880h12454zM17633 15678H436v-1975h17197v1975zm218-2411H218c-120 0-218 98-218 218l1 615v1795c0 121 97 219 217 219h17633c121 0 218-98 218-218v-2411c0-120-98-218-218-218z"
        className="fil0"
      />
      <path
        d="m15407 30349-52 531H2747l-839-8461h14286l-787 7930zm1189-8294c-42-46-100-72-162-72H1667c-61 0-119 26-161 72-41 46-61 106-56 168l882 8897c12 111 105 195 217 195h13003c112 0 206-84 216-195l77-771 806-8127c6-61-14-121-55-167zM11078 5868h726c34-174 69-347 103-519h-726c-1 5-2 11-3 17-33 167-66 334-100 502z"
        className="fil0"
      />
      <path
        d="M1629 12364h14843c138 0 264-118 260-259 0-13-2-26-2-39-96-2748-1399-5182-3723-6682-4-3-8-4-12-6-5-3-11-6-16-9-54-26-107-32-155-20h-434c-35 172-70 346-104 519h511c2070 1359 3252 3529 3400 5978h-5107c-13 67-27 136-41 203-23 119-110 169-201 169-10 1-17 6-27 6-403-1-805 0-1208 0-163-1-259-151-229-301 5-26 11-51 16-77H1903c123-2060 965-4015 2556-5375 469-401 631-568 1169-603 459-31 932 0 1393 0h3574c35-174 69-347 104-519H6030c-252 0-575-56-823 0-610 138-1298 884-1707 1323-1373 1475-2055 3385-2128 5379 0 18-2 36-2 54-5 140 122 259 259 259z"
        className="fil0"
      />
      <path
        d="M11982 1349c56-285 76-633 177-911 23 11 52 22 89 36 168 59 409 38 631 18l-972 4857c-34 172-69 345-103 519-392 1960-785 3921-1177 5882h-726c392-1961 784-3922 1177-5882 34-168 67-335 100-502 1-6 2-12 3-17 267-1334 534-2667 801-4000zM9400 11846c-5 26-11 51-16 77-30 150 66 301 229 301 403-1 805 0 1208 0 11-1 17-5 27-6 91-1 178-50 201-169 14-67 28-135 41-203 399-1993 797-3986 1196-5978 34-173 69-347 104-519 337-1683 673-3366 1010-5049 30-150-66-300-229-300h-1208c-98 0-209 73-229 174l-1035 5175c-35 172-69 345-104 519-398 1992-797 3985-1195 5978z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
